import script from "./PurchaseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseModal.vue?vue&type=script&setup=true&lang=ts"

import "./PurchaseModal.vue?vue&type=style&index=0&id=1172d538&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1172d538"]])

export default __exports__